(function () {
  'use strict';

  /* ── Conference form submission ─────── */
  document.querySelectorAll('form.conf-form').forEach(function (f) {
    var url = f.getAttribute('action') || '';
    var hasCustomEndpoint = url && url !== '#' && !url.includes('/cart');

    f.addEventListener('submit', function (e) {
      e.preventDefault();
      var nameInput = f.querySelector('[name="nombre"]');
      var firstName = (nameInput && nameInput.value.trim().split(/\s+/)[0]) || 'amigo';
      var thanks = f.parentElement.querySelector('.conf-thanks');

      if (hasCustomEndpoint) {
        try {
          fetch(url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: new URLSearchParams(new FormData(f)).toString()
          });
        } catch (err) {}
      }

      f.style.display = 'none';
      if (thanks) {
        var nameEl = thanks.querySelector('.name');
        if (nameEl) nameEl.textContent = firstName;
        thanks.style.display = 'block';
        thanks.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    });
  });

  /* ── Quantity changer ───────────────── */
  window.qtyChange = function (delta) {
    var q = document.getElementById('qty');
    if (!q) return;
    var n = Math.max(1, (parseInt(q.value, 10) || 1) + delta);
    q.value = n;
    updateTotal();
  };

  window.updateTotal = function () {
    var qtyEl = document.getElementById('qty');
    var totalEl = document.getElementById('total');
    var shopForm = document.querySelector('.shop-form');
    if (!qtyEl || !totalEl || !shopForm) return;
    var PRICE = parseInt(shopForm.getAttribute('data-price'), 10) || 0;
    var qty = Math.max(1, parseInt(qtyEl.value, 10) || 1);
    var total = (PRICE * qty).toLocaleString('es-MX', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
    totalEl.textContent = '$' + total + ' MXN';
  };

  var qtyInput = document.getElementById('qty');
  if (qtyInput) {
    qtyInput.addEventListener('input', updateTotal);
  }

  /* ── Contact modal ──────────────────── */
  window.openContact = function () {
    var modal = document.getElementById('contactModal');
    if (!modal) return;
    modal.classList.add('open');
    document.body.style.overflow = 'hidden';
  };

  window.closeContact = function () {
    var modal = document.getElementById('contactModal');
    if (!modal) return;
    modal.classList.remove('open');
    document.body.style.overflow = '';
  };

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeContact();
  });

  var contactForm = document.getElementById('contactForm');
  if (contactForm) {
    contactForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var url = this.getAttribute('action') || '';
      if (url && url !== '#' && !url.includes('#')) {
        try {
          fetch(url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: new URLSearchParams(new FormData(this)).toString()
          });
        } catch (err) {}
      }
      this.style.display = 'none';
      var modalThanks = document.querySelector('#contactModal .modal-thanks');
      if (modalThanks) {
        modalThanks.style.display = 'block';
      }
    });
  }

  /* ── Modal backdrop click ───────────── */
  document.addEventListener('click', function (e) {
    if (e.target.id === 'contactModal') {
      closeContact();
    }
  });

  /* ── Mobile nav toggle ──────────────── */
  window.toggleMobileNav = function () {
    var toggle = document.querySelector('.nav-toggle');
    var menu = document.getElementById('mobileNav');
    if (!toggle || !menu) return;
    toggle.classList.toggle('open');
    menu.classList.toggle('open');
    document.body.style.overflow = menu.classList.contains('open') ? 'hidden' : '';
  };

  window.closeMobileNav = function () {
    var toggle = document.querySelector('.nav-toggle');
    var menu = document.getElementById('mobileNav');
    if (!toggle || !menu) return;
    toggle.classList.remove('open');
    menu.classList.remove('open');
    document.body.style.overflow = '';
  };
})();
